// Tintable vector t-shirt mockups (front & back). The body is filled with the
// chosen garment colour; shading is colour-independent (semi-transparent black
// overlays) so every colour looks right. Placed artwork is never affected.

export type Side = "front" | "back";

// A symmetric tee body + sleeves. Front has a crew neckline; back has a flat
// collar band.
const BODY_FRONT = `
M150 120 C120 122 100 127 90 132 L54 246 Q50 260 65 264 L138 250
Q149 251 151 264 L158 470 Q160 489 179 491 L321 491 Q340 489 342 470
L349 264 Q351 251 362 250 L435 264 Q450 260 446 246 L410 132
C400 127 380 122 350 120 C322 129 300 150 250 158 C200 150 178 129 150 120 Z`;

const BODY_BACK = `
M150 120 C120 122 100 127 90 132 L54 246 Q50 260 65 264 L138 250
Q149 251 151 264 L158 470 Q160 489 179 491 L321 491 Q340 489 342 470
L349 264 Q351 251 362 250 L435 264 Q450 260 446 246 L410 132
C400 127 380 122 350 120 C320 126 288 130 250 130 C212 130 180 126 150 120 Z`;

function svg(color: string, side: Side): string {
  const body = side === "front" ? BODY_FRONT : BODY_BACK;
  const collar =
    side === "front"
      ? `<path d="M198 128 C214 146 234 154 250 154 C266 154 286 146 302 128"
             fill="none" stroke="rgba(0,0,0,0.18)" stroke-width="4" stroke-linecap="round"/>`
      : `<path d="M198 126 C216 138 234 141 250 141 C266 141 284 138 302 126"
             fill="none" stroke="rgba(0,0,0,0.16)" stroke-width="3"/>
         <path d="M206 118 Q250 108 294 118 L292 130 Q250 122 208 130 Z"
             fill="rgba(0,0,0,0.10)"/>`;

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 540" width="500" height="540">
  <defs>
    <linearGradient id="shade" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#000" stop-opacity="0"/>
      <stop offset="0.55" stop-color="#000" stop-opacity="0"/>
      <stop offset="1" stop-color="#000" stop-opacity="0.10"/>
    </linearGradient>
    <radialGradient id="hi" cx="0.5" cy="0.32" r="0.55">
      <stop offset="0" stop-color="#fff" stop-opacity="0.35"/>
      <stop offset="1" stop-color="#fff" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <path d="${body}" fill="${color}" stroke="rgba(0,0,0,0.22)" stroke-width="2"/>
  <path d="${body}" fill="url(#hi)"/>
  <path d="${body}" fill="url(#shade)"/>
  <!-- soft folds -->
  <path d="M175 300 Q250 320 325 300" fill="none" stroke="rgba(0,0,0,0.06)" stroke-width="6" stroke-linecap="round"/>
  <path d="M185 400 Q250 424 315 400" fill="none" stroke="rgba(0,0,0,0.06)" stroke-width="7" stroke-linecap="round"/>
  <path d="M120 210 L150 250" stroke="rgba(0,0,0,0.05)" stroke-width="6" stroke-linecap="round"/>
  <path d="M380 210 L350 250" stroke="rgba(0,0,0,0.05)" stroke-width="6" stroke-linecap="round"/>
  ${collar}
</svg>`;
}

export function garmentDataUrl(color: string, side: Side): string {
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg(color, side));
}
